<template>
    <div>
        <div class="achievements">
            <nationConventionCenterL1 class="achievements1"></nationConventionCenterL1>
        </div>
    </div>
</template>

<script>
import nationConventionCenterL1 from './components/nationCenterOneL1.vue'
export default {
    name: 'ProjectOne',
    components:{ 
        nationConventionCenterL1
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.achievements{
    height:1301px;
    overflow: hidden;
    margin:auto;
    width:1501px;
    margin:0 auto;
    background: url('../../assets/img/pc/achievements.jpg') no-repeat center 0;
    background-size:100% auto;
    .achievements1{
        margin:290px auto 0;
        width:1199px;
    }
}
</style>